<!-- <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#7E24FF" type="ball-fusion">
  <p style="font-size: 22px; color: white">Loading...</p>
</ngx-spinner> -->
<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.4)"
  template="<img src='./assets/images/new_icons/LoadingNew.gif'/>">
</ngx-spinner>
<router-outlet>
</router-outlet>